module.exports = __webpack_public_path__ + "img/smtpemail.8082ecb0.jpeg";